import { Dropdown } from './DropdownComponent';
import { DropdownTrigger } from './DropdownTrigger';

const DD = Object.assign(Dropdown, { Trigger: DropdownTrigger });

export { DD as Dropdown };
